import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';

const AssetFormSkeleton = () => (
  <>
    <div className="input_group" style={{ marginBottom: '2rem' }}>
      <div style={{ marginBottom: '0.8rem' }}>
        <Skeleton variant="text" width="4rem" />
      </div>
      <Skeleton variant="rect" width="100%" height="4.2rem" />
    </div>

    <div className="input_group" style={{ marginBottom: '2rem' }}>
      <div style={{ marginBottom: '0.8rem' }}>
        <Skeleton variant="text" width="6rem" />
      </div>
      <Skeleton variant="rect" width="100%" height="4.2rem" />
    </div>

    <div
      style={{
        marginBottom: '2.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.8rem',
      }}
    >
      <Skeleton variant="rect" width="1.6rem" height="1.6rem" />
      <Skeleton variant="text" width="9rem" />
    </div>

    <div style={{ marginBottom: '2rem' }}>
      <div style={{ marginBottom: '0.8rem' }}>
        <Skeleton variant="text" width="22rem" />
      </div>
      <Skeleton variant="rect" width="100%" height="4.2rem" />
    </div>

    <div>
      <div style={{ marginBottom: '0.8rem' }}>
        <Skeleton variant="text" width="5rem" />
      </div>
      <Skeleton variant="rect" width="100%" height="4.2rem" />
    </div>
  </>
);

export default AssetFormSkeleton;
